module.exports = __webpack_public_path__ + "media/36.d2f15a66.mp3";